import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, doc, setDoc } from "firebase/firestore";

function añadir_QR(infoProducto) {
  const db = getFirestore(firebaseApp);
  const collectionRef = collection(db, "Codigos_QR/");
  const docRef = doc(collectionRef, infoProducto.nombre);
  setDoc(docRef, infoProducto);      
}

export default añadir_QR;
